export const LIBRARY_IMPORT_MAP: Record<string, Array<{ module: string; alias?: string }>> = {
  numpy: [{ module: 'numpy', alias: 'np' }],
  pandas: [{ module: 'pandas', alias: 'pd' }],
  matplotlib: [{ module: 'matplotlib.pyplot', alias: 'plt' }],
  seaborn: [{ module: 'seaborn', alias: 'sns' }],
  tensorflow: [{ module: 'tensorflow', alias: 'tf' }],
  torch: [{ module: 'torch' }],
  'scikit-learn': [{ module: 'sklearn' }],
  scipy: [{ module: 'scipy' }],
  plotly: [
    { module: 'plotly.express', alias: 'px' },
    { module: 'plotly.graph_objects', alias: 'go' },
  ],
  requests: [{ module: 'requests' }],
  httpx: [{ module: 'httpx' }],
  keras: [{ module: 'keras' }],
  lightgbm: [{ module: 'lightgbm', alias: 'lgb' }],
  catboost: [{ module: 'catboost' }],
  xgboost: [{ module: 'xgboost', alias: 'xgb' }],
};
